import type { Breadcrumb } from '../types.js';

export interface LoggerState {
  user?: string;
  tenant?: string;
  context?: Record<string, unknown>;
  tags?: string[];
  sessionId: string;
  enabled: boolean;
  initialized: boolean;
  breadcrumbs: Breadcrumb[];
}

export function createState(initial: {
  user?: string;
  tenant?: string;
  context?: Record<string, unknown>;
  tags?: string[];
  sessionId: string;
  enabled: boolean;
}): LoggerState {
  const state: LoggerState = {
    sessionId: initial.sessionId,
    enabled: initial.enabled,
    initialized: false,
    breadcrumbs: [],
  };
  if (initial.user !== undefined) state.user = initial.user;
  if (initial.tenant !== undefined) state.tenant = initial.tenant;
  if (initial.context !== undefined) state.context = { ...initial.context };
  if (initial.tags !== undefined) state.tags = [...initial.tags];
  return state;
}
